module.exports = __webpack_public_path__ + "static/img/logo.5f2b6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/list/assets/img/logo.png
// module id = 33
// module chunks = 1 2 3 4 5